import { render, staticRenderFns } from "./rule-setNew.vue?vue&type=template&id=63c17251&scoped=true&"
import script from "./rule-setNew.vue?vue&type=script&lang=js&"
export * from "./rule-setNew.vue?vue&type=script&lang=js&"
import style0 from "./rule-setNew.vue?vue&type=style&index=0&id=63c17251&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c17251",
  null
  
)

export default component.exports